import React from "react";
import icon1 from "../../assets/images/customer-icon/icon-1.png";

const Customer = () => {
  const data = [
    {
      img: require("../../assets/images/customer-icon/icon-1.png"),
      title: "Safe Delivery",
      phara: "Duration with 7 Business Days",
    },
    {
      img: require("../../assets/images/customer-icon/icon-2.png"),
      title: "Customer Support",
      phara: "Dedicated Mobile Support",
      whatsapp: "3544988",
    },
    {
      img: require("../../assets/images/customer-icon/icon-3.png"),
      title: "Business Opportunity",
      phara: "Distributor & franchise",
    },
    {
      img: require("../../assets/images/customer-icon/icon-4.png"),
      title: "Secure Payment",
      phara: "100% Secure Payment",
    },
  ];

  const handleClick = (whatsappNumber) => {
    window.open(`https://wa.me/${whatsappNumber}`, "_blank");
  };

  return (
    <div className="customer-bg pt-40 pb-40">
      <div className="container">
        <div className="row">
          {data.flatMap((item, index) => {
            return (
              <div
                className="col-xl-3 col-lg-6 col-md-6 customer-main"
                key={index}
                onClick={() => item.whatsapp && handleClick(item.whatsapp)}
              >
                <div>
                  <img src={item.img} alt="icon" className={item.title} />
                </div>
                <div className="costomer-cont">
                  <h6>{item.title}</h6>
                  <p>{item.phara}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Customer;
